<pbc-filter [config]="BereichsFilterConfig" [filter]="bereichs.filter$ | async" (filterChange)="bereichs.filter$.next($event)"></pbc-filter>
